module.exports = __webpack_public_path__ + "static/media/notreatmentsetup.eff67512.svg";